import { PlatformDomain } from "../../apis/mgmt/api";
import { DataFormWithButtonsLayout } from "../common/DataFormWithButtonsLayout";
import { EditableProps } from "../common/Editable";
import { PlatformDomainFormWithConfig } from "./PlatformDomainFormWithConfig";


export const PlatformDomainEditable = function (
    props: EditableProps<PlatformDomain>
) {
    
    return (
        <DataFormWithButtonsLayout editableProps={props}>
            <PlatformDomainFormWithConfig {...props} />
        </DataFormWithButtonsLayout>
    );

};
